import { render, staticRenderFns } from "./case-data-add.vue?vue&type=template&id=4f444e70&"
import script from "./case-data-add.vue?vue&type=script&lang=js&"
export * from "./case-data-add.vue?vue&type=script&lang=js&"
import style0 from "./case-data-add.vue?vue&type=style&index=0&id=4f444e70&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports